export const isWorkingDay = (date: Date): boolean => {
    const comparableDay = date.getDate() + "." + (date.getMonth() + 1);
    const isSaturday = date.getDay() === 6;
    const isSunday = date.getDay() === 0;
    const holidays = getHolidays(date.getFullYear());
    const isHoliday = holidays.includes(comparableDay);

    return !isHoliday && !isSaturday && !isSunday;
};

export const getEasterDate = (year: number): Date => {
    const date = new Date();
    // Set the timestamp to midnight.
    date.setHours(0, 0, 0, 0);
    // Set the year.
    date.setFullYear(year);
    // Find the golden number.
    const a = year % 19;
    // Choose which version of the algorithm to use based on the given year.
    const b = 2200 <= year && year <= 2299 ? (11 * a + 4) % 30 : (11 * a + 5) % 30;
    // Determine whether or not to compensate for the previous step.
    const c = b === 0 || (b === 1 && a > 10) ? b + 1 : b;
    // Use c first to find the month: April or March.
    const m = 1 <= c && c <= 19 ? 3 : 2;
    // Then use c to find the full moon after the northward equinox.
    const d = (50 - c) % 31;
    // Mark the date of that full moon—the "Paschal" full moon.
    date.setMonth(m, d);
    // Count forward the number of days until the following Sunday (Easter).
    date.setMonth(m, d + (7 - date.getDay()));

    // Gregorian Western Easter Sunday
    return date;
};

const getHolidays = (year: number) => {
    const LVHolidays = ["1.1", "1.5", "4.5", "23.6", "24.6", "18.11", "24.12", "25.12", "31.12"];

    const easter = getEasterDate(year);
    const bigFriday = addDays(easter, -2);
    const secondEaster = addDays(easter, 1);

    LVHolidays.push(
        bigFriday.getDate() + "." + (bigFriday.getMonth() + 1),
        secondEaster.getDate() + "." + (secondEaster.getMonth() + 1)
    );

    return LVHolidays;
};

export const addDays = (date: Date, days: number): Date =>
    new Date(
        date.getFullYear(),
        date.getMonth(),
        date.getDate() + days,
        date.getHours(),
        date.getMinutes(),
        date.getSeconds(),
        date.getMilliseconds()
    );

export const getFirstAllowedWorkday = (workDayGap: number): Date => {
    const today = new Date(Date.now());
    today.setHours(0);
    today.setMinutes(0);
    today.setSeconds(0);
    today.setMilliseconds(0);
    let minAllowedWorkDay: Date;
    let workDays = 0;

    for (let i = 1; i < 30; i++) {
        const incrementedDay = addDays(today, i);
        !minAllowedWorkDay && isWorkingDay(new Date(incrementedDay)) && workDays++;

        if (workDays >= workDayGap) {
            minAllowedWorkDay = incrementedDay;
            break;
        }
    }

    return minAllowedWorkDay;
};
